// After a deploy an open tab may lazy-load a chunk that no longer exists
// (hashed name changed, old file gone). Vite reports that as a cancelable
// `vite:preloadError` window event; a plain `import()` surfaces as an
// unhandled rejection. Either way: one full reload per build per session
// (guard in chunkReloadGuard.ts); a second failure is left to surface.
import { isChunkLoadError, shouldReloadForChunkError } from "./chunkReloadGuard";
import { getCurrentBuildId, safeSessionStorage } from "./browser";

let installed = false;

/** Reloads once per build/session; true when a reload was triggered. */
export function tryReloadForChunkError(): boolean {
  if (!shouldReloadForChunkError(safeSessionStorage(), getCurrentBuildId())) return false;
  window.location.reload();
  return true;
}

export function installChunkLoadRecovery(): void {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("vite:preloadError", (event) => {
    if (tryReloadForChunkError()) event.preventDefault();
  });
  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event.reason) && tryReloadForChunkError()) event.preventDefault();
  });
}
